import type { QueryClient } from '@tanstack/react-query';
import type {
  KGSummaryListResponse,
  KGSummaryResponse,
} from '@/lib/api/knowledgeGaps';

export function patchKnowledgeGapSummaryCache(
  queryClient: QueryClient,
  orgId: string,
  updated: KGSummaryResponse,
) {
  queryClient.setQueriesData<KGSummaryListResponse>(
    { queryKey: ['knowledge-gaps-summaries', orgId] },
    (old) => {
      if (!old) return old;
      return {
        ...old,
        summaries: old.summaries.map((summary) =>
          summary.id === updated.id ? updated : summary,
        ),
      };
    },
  );

  queryClient.setQueryData(
    ['knowledge-gap-summary-detail', orgId, updated.id],
    updated,
  );
}
